module.exports = __webpack_public_path__ + "img/arrow-down.b6f80df6.svg";